import React, { memo } from "react";
import { getSdk } from "../../services/sdkService";
import {
  CAROUSEL_TYPES,
  withFocusable,
  Loading,
  ModalSettings,
  Button,
  Toast,
  Text,
  AirRemoteArrows
} from "../../services/visualLibraryService";
import { goToDetailPageByProgramType } from "../../utils/goToDetailPage";
import {
  LayoutStyled,
  ButtonStyled,
  ArrowScrollStyled,
  ShadowLayoutStyled,
  IconStyled,
  LayoutUpArrow,
  LayoutDownArrow,
  UpArrow,
  FillBtnUpArrow,
  DownArrow,
  FillBtnDownArrow,
  LayoutEmptyStyled
} from "./styles/Styled";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { playHandler, play } from "../../utils/mediaDataRetrieval";
import { getLocaleFromLocalCache } from "../../services/localeCacheService";
import getBrands from "../../services/layoutService";
import { getSavedFocusInfo, removeSavedFocusInfo, saveFocusInfo } from "../../services/layoutService";
import getSportsAddons, { getSpSportsPackageDisplayName } from "../../services/sportPackageService";
import { isSpSportsAddonContent } from "../../services/sportPackageService";
import {
  isUserSubscribedToChannel,
  isChannelAvailable,
  showChannelSubscriptionErrorPopup,
  showChannelSubscriptionErrorPopupNew,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom,
  getBrandName,
  getBrandLogoUrl,
  isStarzPlaySubscription
} from "../../utils/subscriptionUtils";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { getTitlesFormattedForHeroCarousel, isFVODFreeToAir } from "../../utils/fvodUtils";
import { withAppState, getAppState } from "../../state";
import { i18n, directions } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonFocusPath, getGlobalButtonInfo } from "../../errors/globalButtons";
import { CellMeasurer, CellMeasurerCache, List } from "react-virtualized";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import { defaultFocusPath as mediaControlFocusPath } from "../../components/MediaControlsList";
import { config } from "../../config/config";
import throttle from "../../helpers/throttle";
import {
  trackPage,
  trackEvent,
  getLayoutEventLabel,
  trackEventPushData,
  trackEventInitializeData
} from "../../services/analyticsService";
import { resolution } from "../../config/ui/resolutionConfig";
import { routes } from "../../routes";
import { showResolutionModal, showNotLoggedModal, showInvalidStatusModal } from "../../services/modalsService";
import {
  sameLayoutRequestIsInProgress,
  setLayoutRequestInProgress,
  unsetLayoutRequestInProgress
} from "./layoutNetworkUtils";
import { starz2 as Theme } from "starz-visual-themes";
import { sections } from "../../routes";
import { getPath } from "../../utils/getPath";
import { findFromBrands } from "../../helpers/find";
import { getNavigationReferences } from "../../services/navigationService";
import { isSuitableFor4KPlayback, has4KProgramId } from "../../services/titleDataService";
import { getConfigForModalWithCloseButton } from "../../errors/globalButtons";
//import HeroFullscreen from "../../components/HeroFullscreen";
import MediaControlsList from "../../components/MediaControlsList/MediaControlsList";
import getMediaItems from "../../components/MediaControlsList/mediaItems";
import { getCacheGeneratedImage } from "../../utils/staticCache";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { ButtonStyled as ModalButtonStyled } from "../../components/ModalSettings/styles/Styled";

const noHeader = url => url.search(/\/brands\/.*?(?=$|\/$)/) === 0;

const YEAR_CONST = 2018;

const NO_HEADER_MARGIN_TOP_IN_PX = 196; // 10.2rem top margin if no hero carousel

const MediaControlsListFocus = withFocusable(MediaControlsList);

const PAGE = "layout";
const PLAY_FROM_LABEL = "cw_home";
const INITIAL_MODULE = 0;
const ButtonModalFocus = withFocusable(ModalButtonStyled);
const ListReferenced = props => <List {...props}>{props.children}</List>;
const ListFocus = withFocusable(ListReferenced);
const defaultFocusPath = "lists";

let sdk = null;
let mediaSlider;
var timer = null;
// let listRef = null;
// FIXME: WBIGS-690 - Remove with new carousel
let rtlToFix = 0;
const width = window.innerWidth;
const height = window.innerHeight;
let amountOfDownloadedModules = {};
const isBrand = window.location.pathname.includes("brands");

function buildAmountOfDownloadedModulesObject() {
  Object.values(sections).forEach(section => {
    section !== "search" && (amountOfDownloadedModules[section] = 0);
  });
}

function getErrorHandlingCallbacks(finalModule, isLayoutExpired = false) {
  const {
    stateActions: { hideGlobalModal },
    history: { goBack }
  } = this.props;
  const retry = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    this.getLayout(INITIAL_MODULE, finalModule, isLayoutExpired);
  };
  const back = () => {
    this.setState({ didPlayerLaunch: false });
    hideGlobalModal();
    goBack();
  };

  return { retry, back };
}

/**
 * Handles the error received from getLayout request.
 * @param {Error} error - Error thrown.
 * @param finalModule
 */
async function handleError(error, finalModule = this.getFinalModule()) {
  const {
    stateActions: { showGlobalModal },
    resumeNavigation,
    setFocus
  } = this.props;
  const isLayoutExpired = error.error_code === sdk.mediaManager.mediaErrorCodes.LAYOUT_EXPIRED;
  const { retry, back } = getErrorHandlingCallbacks.call(this, finalModule, isLayoutExpired);

  if (isLayoutExpired) {
    this.props.applicationState.userRelatedModules = null;
    this.getLayout(INITIAL_MODULE, finalModule, isLayoutExpired);
  } else if (!this.state.modules || this.state.modules.modules.length === 0) {
    // Only show errors if there are no modules on screen, otherwise, ignore
    // TODO There are cases when the timeout error message appears like "Gateway Time-out". It should enter in the if
    // Example: When a call to a layout section returns a 503
    if (getAppState().isOnline && error && error.message.indexOf("timeout") > -1) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back,
          needsDismissableProp: false,
          isTimeout: true
        })
      );
    } else if (!getAppState().isOnline && !error.status && !error.response) {
      showGlobalModal(
        getInternetConnectivityModalConfig.call(this, {
          retryImplementation: retry,
          backImplementation: back
        })
      );
    } else {
      const buttons = [
        {
          ...getGlobalButtonInfo("retry"),
          buttonHandler: retry
        },
        {
          ...getGlobalButtonInfo("back"),
          buttonHandler: back
        }
      ];
      showGlobalModal({
        modalText: i18n.get("global.errors.genericError"),
        buttons
      });
    }
    resumeNavigation();
    setFocus(getGlobalButtonFocusPath("retry"));
  }
}

function getAddonName(addon) {
  return config.get().addonNames[addon] || addon;
}

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wheelState: "idle",
      isLoading: false,
      modules: null,
      nameSection: getPath(this.props),
      modal4K: false,
      isExiting: false,
      scrollToIndex: -1,
      initialScroll: 0,
      didPlayerLaunch: false,
      isLastRowHeightCache: false,
      mediaControlMenu: getMediaItems(),
      hasHeroModule: false,
      isLoaded: true
    };
    this.sections = [];
    this.videoConfig = {};
    this.has4K = false;
    this.initialFocus = defaultFocusPath;
    this.play4KModalFocusPath = null;
    this.confirmModalFocusPath = null;
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
    this.playFromLabel = PLAY_FROM_LABEL;
    this.onChangeItem = this.onChangeItem.bind(this);
    this.close4KModal = this.close4KModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.appNeedToClose = this.appNeedToClose.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleMediaControlsEnter = this.handleMediaControlsEnter.bind(this);
    this.isRowFocused = this.isRowFocused.bind(this);
    this.isCropped = this.isCropped.bind(this);
    this._onModulesUp = this._onModulesUp.bind(this);
    this._onModulesDown = this._onModulesDown.bind(this);
    this._onModulesLeft = this._onModulesLeft.bind(this);
    this._onModulesRight = this._onModulesRight.bind(this);
    this.rowHeightCalculator = this.rowHeightCalculator.bind(this);
    this.dontShowEmptyActive = this.dontShowEmptyActive.bind(this);
    this.getListRowCount = this.getListRowCount.bind(this);
    this.updateCarouselStateIndexes = this.updateCarouselStateIndexes.bind(this);
    this.getInitialSlide = this.getInitialSlide.bind(this);
    this.getLayout = this.getLayout.bind(this);
    this.onBack = this.onBack.bind(this);
    this.goTop = this.goTop.bind(this);
    this.onEnterPlay = this.onEnterPlay.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.slideUpDown = this.slideUpDown.bind(this);
    //onclicks binds
    this.openFullCatalogLayout = this.openFullCatalogLayout.bind(this);
    this.onClickPoster = this.onClickPoster.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
    this.rowHeightCalculator = this.rowHeightCalculator.bind(this);

    this.onRefCarousel = this.onRefCarousel.bind(this);
    this.onMediaControlsLeft = this.onMediaControlsLeft.bind(this);
    this.onMediaControlsRight = this.onMediaControlsRight.bind(this);
    this.showAnimations = config.get().ui.animations;
    this.throttleTime = config.get().ui.throttle;
    const backToTopConfig = config.get().featureToggles.backToTop;
    this.carouselToShowBack = backToTopConfig && backToTopConfig.carouselToShowBack;
    this.scrollPositions = [];
    this.onModulesUp = throttle(this._onModulesUp, this.throttleTime.medium);
    this.onModulesDown = throttle(this._onModulesDown, this.throttleTime.medium);
    this.onModulesLeft = throttle(this._onModulesLeft, this.throttleTime.medium);
    this.onModulesRight = throttle(this._onModulesRight, this.throttleTime.medium);
    this.isSports = window.location.pathname.includes("sports");
    this.onMediaControlsDown = this.onMediaControlsDown.bind(this);
    this.onMediaControlsUp = this.onMediaControlsUp.bind(this);
    this.handleMediaControlsActions = this.handleMediaControlsActions.bind(this);
    this.closeGlobalModal = this.closeGlobalModal.bind(this);
    const isBrand = window.location.pathname.includes("brands");
    this.brandName = isBrand && window.location.pathname.split("/")[1];
    this.cache = new CellMeasurerCache({
      defaultHeight: height / 3,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        const data = this.state.modules?.modules[rowIndex];
        if (data) {
          return `${data?.id}`;
        } else {
          return `${rowIndex + columnIndex}`;
        }
      }
      // keyMapper: (rowIndex, columnIndex) => {
      //   const data = this.state.modules?.modules[rowIndex];
      //   if (rowIndex <= 2) {
      //     return `${data?.id}-${rowIndex}-${columnIndex}`;
      //   }
      //   if (this.cache._rowHeightCache["2-0"]) {
      //     return "2-0";
      //   }
      //   if (this.cache._rowHeightCache[`${data?.id}-${rowIndex - 1}-${columnIndex}`]) {
      //     return `${data?.id}-${rowIndex - 1}-${columnIndex}`;
      //   }
      //   return `${data?.id}-${rowIndex}-${columnIndex}`;
      // }
    });

    this.videoData = null;

    this.TypedCarouselStyledMemo = memo(
      props => {
        return <TypedCarouselStyled onClickPoster={i => this.onClickPoster(i)} {...props} />;
      },
      (props, newProps) => {
        return (
          props.style.height !== "auto" &&
          props.style.height !== newProps.style.height &&
          props.style.top !== newProps.style.top &&
          props.className === newProps.className &&
          props.showArrows !== newProps.showArrows
        );
      }
    );
    Object.keys(amountOfDownloadedModules).length === 0 && buildAmountOfDownloadedModulesObject();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // FIXME: Try to remove focus path for preventing the modification of scrollToIndex
    const focus4kModal = ["play4KModal_passThru", "playHDModal_passThru"];
    if (
      nextProps.applicationState.currentFocus !== defaultFocusPath &&
      !focus4kModal.includes(nextProps.applicationState.currentFocus)
    ) {
      if (prevState.isExiting) {
        return null;
      } else if (nextProps.applicationState.currentFocus === "buttonPlay") {
        return {
          scrollToIndex: nextProps.applicationState.focusedCarouselIndex || 0
        };
      } else {
        if (prevState.isWheel) {
          if (
            nextProps.currentFocus == "mainMenu" &&
            prevState.scrollToIndex == 0 &&
            prevState.scrollDirection == "up"
          ) {
            return {
              scrollToIndex: -1
            };
          } else {
            return {};
          }
        } else {
          return {
            scrollToIndex: -1
          };
        }
      }
    } else if (prevState.scrollToIndex === -1) {
      if (
        i18n.getDirection() === directions.RIGHT_TO_LEFT &&
        rtlToFix === 2 &&
        nextProps.applicationState.focusedCarouselIndex &&
        nextProps.applicationState.focusedCarouselItemIndex
      ) {
        rtlToFix = 1;
        nextProps.applicationState.focusedCarouselItemIndex -= 1;
      }

      return {
        scrollToIndex:
          prevState.isWheel && prevState.wheelState == "active"
            ? prevState.scrollToIndex
            : nextProps.currentFocus == defaultFocusPath
            ? nextProps.applicationState.focusedCarouselIndex
            : nextProps.applicationState.focusedCarouselIndex || 0,
        initialScroll: nextProps.applicationState.layoutScrollTop
      };
    } else {
      return null;
    }
  }

  onClickPoster(itemIndex) {
    this.goTo(itemIndex);
  }
  onClickRow(i, rowIndex) {
    this.setState(() => ({ scrollToIndex: rowIndex }), this.updateCarouselStateIndexes);
    this.onClickPoster(i);
  }

  // FIXME: This function doesn't scale so well. What will happen when we have 15 possible popups and 10 different scenarios?
  onBack() {
    const {
      history: { location }
    } = this.props;
    const globalModal = getAppState().globalModal;
    if (globalModal && globalModal.dismissable && !getAppState().isOnline) {
      this.props.stateActions.hideGlobalModal();
      getSdk().systemManager.application.exit();
    } else if (this.state.modal4K) {
      // Close 4K prompt.
      this.close4KModal();
    } else if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
    } else if (this.state.didPlayerLaunch) {
      // Cancel player launch
      this.setState({ didPlayerLaunch: false });
      this.props.resumeNavigation();
    } else if (
      (!globalModal || globalModal.dismissable) &&
      this.isEnabled() &&
      this.props.applicationState.currentFocus === "mainMenu" &&
      config.get().featureToggles.exitAppPopup
    ) {
      // Show exit popup
      this.setState({ isExiting: true });
    } else if (globalModal && !globalModal.dismissable) {
      this.closeGlobalModal();
    } else if (this.state.scrollToIndex > this.carouselToShowBack) {
      // Going top if reached carouselToShowBack config
      this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      return true;
    } else if (location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      this.props.history.goBack();
    } else if (!location.pathname.includes("brands") && this.state.scrollToIndex <= this.carouselToShowBack) {
      // this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      this.setState({ scrollToIndex: 0 });
      this.props.setFocus(headerFocusPath);
      mediaSlider.down();
      return true;
    }
    this.props.stateActions.setMediaControlItemFocus(-1);
    return true;
  }

  goTop() {
    if (this.state.scrollToIndex > this.carouselToShowBack) {
      // Going top if reached carouselToShowBack config
      this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
    }
  }

  isEnabled = () => !!this.state.modules && !this.state.didPlayerLaunch;

  closeGlobalModal = () => {
    const {
      location,
      setFocus,
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    let { name: from, currentFocus, index } = getSavedFocusInfo();
    removeSavedFocusInfo();
    const isHome =
      (from === "/home" && location.pathname === "/") ||
      (from === "/" && location.pathname === "/home") ||
      (from === "/" && location.pathname === "/")
        ? true
        : false;
    if (from === location.state?.from?.name || from === location.pathname || isHome) {
      if (currentFocus === "mediaControls" && index >= 0) {
        this.props.stateActions.setMediaControlItemFocus(index);
      }
      this.props.setFocus(currentFocus || defaultFocusPath);
      return;
    }
    setFocus(defaultFocusPath);
  };

  /**
   * New method to handle Hero action buttons functionalities. Play/Trailer/Info.
   *  */

  async handleMediaControlsActions() {
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, currentFocus, focusedMediaControlItemIndex },
      stateActions: { showGlobalModal, hideGlobalModal, setPreviousFocusForBackBehavior }
    } = this.props;

    const module = this.state.modules.modules[0];
    const { type, category, id: moduleId, friendlyTitle, layoutOrder } = module;
    const videoData = this.sections[0].handleAction();
    const { id, programType, progress, seriesId, addonContent } = videoData;
    const isThisDeviceSupported = userLogged ? await isSupportedDeviceForMobileLite.call(this, addonContent) : true;
    const currentAddOn = getAddOnByName(addonContent);
    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId
    };

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const CurrentMediaControlList = this.state.mediaControlMenu;
    const selectedMediaControl =
      CurrentMediaControlList[focusedMediaControlItemIndex] &&
      CurrentMediaControlList[focusedMediaControlItemIndex]?.name;

    switch (selectedMediaControl) {
      case "play": // play button
        if (userLogged) {
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            return showInvalidStatusModal.call(this, this.closeGlobalModal);
          }
          if (isCricketAddOn(addonContent) && isCricketAcquiresFrom(addonContent)) {
            if (!isUserSubscribedToChannel(addons, addonContent) && isT20ChildSubscribed(addonContent)) {
              /// if parent is subscribed but t20 is not then only show t20 error
              return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
            } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ChildSubscribed(addonContent)) {
              /// if parent and t20 are not subscribed then show t20 + Cricket error
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                `${currentAddOn.displayName} & ${CricChildAddOn(addonContent)?.displayName}`
              );
            }
          } else if (isT20AddOn(addonContent)) {
            if (!isUserSubscribedToChannel(addons, addonContent) && isT20ParentSubscribed(addonContent)) {
              /// if parent is subscribed but t20 is not then only show t20 error
              return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
            } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ParentSubscribed(addonContent)) {
              /// if parent and t20 are not subscribed then show t20 + Cricket error
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                `${T20ParentAddOn(addonContent)?.displayName} & ${currentAddOn.displayName}`
              );
            }
          } else {
            if (
              isMainPackageAddOn(addonContent) &&
              isSpSportsAddonContent(addonContent) &&
              !isUserSubscribedToSpSportsChannel(addons, addonContent)
            ) {
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                getSpSportsPackageDisplayName()
              );
            }
            if (
              !isMainPackageAddOn(addonContent) &&
              !isStandAloneAddon(addonContent) &&
              isSpSportsAddonContent(addonContent) &&
              !isUserSubscribedToSpSportsChannel(addons, addonContent)
            ) {
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                getSpSportsPackageDisplayName()
              );
            }
            if (!isUserSubscribedToChannel(addons, addonContent)) {
              return showChannelSubscriptionErrorPopup.call(this, this.closeGlobalModal);
            }
          }

          if (!isThisDeviceSupported) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
          }

          if (!!getAppState().isOnline) {
            playHandler.call(this, undefined, {
              from: {
                name: this.props.location.pathname || this.props.from,
                currentFocus: this.props.currentFocus,
                index: focusedMediaControlItemIndex
              }
            });
            //this.props.stateActions.setCarouselItemFocus(0);
          } else {
            const retry = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              this.getLayout();
            };

            const back = () => {
              this.setState({ didPlayerLaunch: false });
              hideGlobalModal();
              history.goBack();
            };
            showGlobalModal(
              getInternetConnectivityModalConfig.call(this, {
                retryImplementation: retry,
                backImplementation: back
              })
            );
            setFocus(getGlobalButtonFocusPath("retry"));
          }
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "trailer": // trailor
        const trailerData = {
          videoType: "trailer",
          id: id,
          moduleId: moduleId,
          moduleType: type,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        };
        const pathname = routes.player;
        history["push"]({
          pathname,
          ...(trailerData && {
            state: trailerData
          })
        });

        break;

      default:
        // info button
        goToDetailPageByProgramType.call(this, {
          id,
          programType,
          moduleId,
          sectionName: this.state.nameSection,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        });
    }
  }

  async handleMediaControlsEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, currentFocus },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    if (this.state.scrollToIndex === -1 && currentFocus === mediaControlFocusPath) {
      this.handleMediaControlsActions();
      return;
    }
  }

  async handleEnter() {
    if (this.state.didPlayerLaunch) {
      return;
    }
    const {
      setFocus,
      history,
      applicationState: { userAccountStatus, addons, userLogged, focusedMediaControlItemIndex },
      stateActions: { showGlobalModal, hideGlobalModal }
    } = this.props;

    saveFocusInfo({
      name: this.props.location.pathname || this.props.from,
      currentFocus: this.props.currentFocus,
      index: focusedMediaControlItemIndex
    });

    const index = this.state.scrollToIndex;
    /**
     * below commented check was there for Explore button present in other layout pages except home (movies/tvshows/arabic etc) pages  below the first carousel
     * So there was some logic implemeneted earlier team for focus managment and position to place below firts carousel in grid layout row.
     *  As per the new UI revamp(Android theme) need to plae Explore button end of the page , so prevoius logics has to be scrapped.
     *  */

    /*const moduleIndex = this.state.nameSection !== "home" && this.state.scrollToIndex > 0 ? index - 1 : index;
     if (this.state.nameSection !== "home" && this.state.scrollToIndex === 1)
    */
    const moduleIndex = index;
    if (
      this.state.nameSection !== "home" &&
      this.state.scrollToIndex === amountOfDownloadedModules[this.state.nameSection]
    ) {
      trackEvent("explore catalogue", this.state.nameSection, this.state.nameSection);
      return this.goFullCatalog();
    }
    const module = this.state.modules.modules[moduleIndex];
    const { type, category, id: moduleId, friendlyTitle, layoutOrder } = module;
    const videoData = this.sections[index].handleAction();
    const { id, programType, progress, seriesId, addonContent } = videoData;
    const currentAddOn = getAddOnByName(addonContent);

    this.videoConfig = {
      id,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"],
      moduleId // FIXME this is not actually something related to video, it should not be here
    };
    trackEvent(
      "browsing|layout_modules",
      `${this.state.nameSection}|${category}`,
      await getLayoutEventLabel(category, layoutOrder, this.sections[index].selectedIndex, friendlyTitle)
    );

    switch (type) {
      case "LiveChannels": // Live carousel
        if (userLogged) {
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
            return showInvalidStatusModal.call(this, this.closeGlobalModal);
          }
          if (isCricketAddOn(addonContent) && isCricketAcquiresFrom(addonContent)) {
            if (!isUserSubscribedToChannel(addons, addonContent) && isT20ChildSubscribed(addonContent)) {
              /// if parent is subscribed but t20 is not then only show t20 error
              return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
            } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ChildSubscribed(addonContent)) {
              /// if parent and t20 are not subscribed then show t20 + Cricket error
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                `${currentAddOn.displayName} & ${CricChildAddOn(addonContent)?.displayName}`
              );
            }
          } else if (isT20AddOn(addonContent)) {
            if (!isUserSubscribedToChannel(addons, addonContent) && isT20ParentSubscribed(addonContent)) {
              /// if parent is subscribed but t20 is not then only show t20 error
              return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
            } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ParentSubscribed(addonContent)) {
              /// if parent and t20 are not subscribed then show t20 + Cricket error
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                `${T20ParentAddOn(addonContent)?.displayName} & ${currentAddOn.displayName}`
              );
            }
          } else {
            if (
              isMainPackageAddOn(addonContent) &&
              isSpSportsAddonContent(addonContent) &&
              !isUserSubscribedToSpSportsChannel(addons, addonContent)
            ) {
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                getSpSportsPackageDisplayName()
              );
            }
            if (
              !isMainPackageAddOn(addonContent) &&
              !isStandAloneAddon(addonContent) &&
              isSpSportsAddonContent(addonContent) &&
              !isUserSubscribedToSpSportsChannel(addons, addonContent)
            ) {
              return showSportPackageSubscriptionErrorPopup.call(
                this,
                this.closeGlobalModal,
                getSpSportsPackageDisplayName()
              );
            }
            if (!isUserSubscribedToChannel(addons, addonContent)) {
              return showChannelSubscriptionErrorPopupNew.call(this, this.closeGlobalModal);
            }
          }

          this.setState(
            {
              isLoaded: false
            },
            async () => {
              const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
              this.setState({ isLoaded: true });
              if (!isThisDeviceSupported) {
                return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
              }

              if (!!getAppState().isOnline) {
                playHandler.call(this, {
                  from: {
                    name: this.props.location.pathname || this.props.from,
                    currentFocus: this.props.currentFocus,
                    index: focusedMediaControlItemIndex
                  }
                });
                this.props.stateActions.setCarouselItemFocus(0);
              } else {
                const retry = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  this.getLayout();
                };

                const back = () => {
                  this.setState({ didPlayerLaunch: false });
                  hideGlobalModal();
                  history.goBack();
                };
                showGlobalModal(
                  getInternetConnectivityModalConfig.call(this, {
                    retryImplementation: retry,
                    backImplementation: back
                  })
                );
                setFocus(getGlobalButtonFocusPath("retry"));
              }
            }
          );
        } else {
          showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeGlobalModal);
        }
        break;

      case "cw": // continue watching
      // check if the content is free to play(f2p)
      let isContentFreeToPlay = false
      if(videoData && videoData.tags){
        isContentFreeToPlay = !isUserAccountActive(userAccountStatus) && isFVODFreeToAir(videoData.tags)
      }
      // console.log("videoData rfom CW carousel: ",videoData)
        // FIXME This could be better done without a magic string, but the new carousel refacroting will change all this
        if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent) && !isContentFreeToPlay) {
          return showInvalidStatusModal.call(this, this.closeGlobalModal);
        }

        if (isCricketAddOn(addonContent) && isCricketAcquiresFrom(addonContent)) {
          if (!isUserSubscribedToChannel(addons, addonContent) && isT20ChildSubscribed(addonContent)) {
            /// if parent is subscribed but t20 is not then only show t20 error
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
          } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ChildSubscribed(addonContent)) {
            /// if parent and t20 are not subscribed then show t20 + Cricket error
            return showSportPackageSubscriptionErrorPopup.call(
              this,
              this.closeGlobalModal,
              `${currentAddOn.displayName} & ${CricChildAddOn(addonContent)?.displayName}`
            );
          }
        } else if (isT20AddOn(addonContent)) {
          if (!isUserSubscribedToChannel(addons, addonContent) && isT20ParentSubscribed(addonContent)) {
            /// if parent is subscribed but t20 is not then only show t20 error
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeGlobalModal, currentAddOn.displayName);
          } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ParentSubscribed(addonContent)) {
            /// if parent and t20 are not subscribed then show t20 + Cricket error
            return showSportPackageSubscriptionErrorPopup.call(
              this,
              this.closeGlobalModal,
              `${T20ParentAddOn(addonContent)?.displayName} & ${currentAddOn.displayName}`
            );
          }
        } else {
          if (
            isMainPackageAddOn(addonContent) &&
            isSpSportsAddonContent(addonContent) &&
            !isUserSubscribedToSpSportsChannel(addons, addonContent)
          ) {
            return showSportPackageSubscriptionErrorPopup.call(
              this,
              this.closeGlobalModal,
              getSpSportsPackageDisplayName()
            );
          }
          if (
            !isMainPackageAddOn(addonContent) &&
            !isStandAloneAddon(addonContent) &&
            isSpSportsAddonContent(addonContent) &&
            !isUserSubscribedToSpSportsChannel(addons, addonContent)
          ) {
            return showSportPackageSubscriptionErrorPopup.call(
              this,
              this.closeGlobalModal,
              getSpSportsPackageDisplayName()
            );
          }
          if (!isUserSubscribedToChannel(addons, addonContent)) {
            return showChannelSubscriptionErrorPopupNew.call(this, this.closeGlobalModal);
          }
        }

        this.setState(
          {
            isLoaded: false
          },
          async () => {
            const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
            this.setState({ isLoaded: true });
            if (!isThisDeviceSupported) {
              return showUnSupportedDeviceErrorPopup.call(this, this.closeGlobalModal);
            }

            if (getAppState().isOnline) {
              playHandler.call(this);
              this.props.stateActions.setCarouselItemFocus(0);
            } else {
              const retry = () => {
                this.setState({ didPlayerLaunch: false });
                hideGlobalModal();
                this.getLayout();
              };

              const back = () => {
                this.setState({ didPlayerLaunch: false });
                hideGlobalModal();
                history.goBack();
              };
              showGlobalModal(
                getInternetConnectivityModalConfig.call(this, {
                  retryImplementation: retry,
                  backImplementation: back
                })
              );
              setFocus(getGlobalButtonFocusPath("retry"));
            }
          }
        );

        break;
      case "channels":
        const itemToRedirect = module.titles[getAppState().focusedCarouselItemIndex];
        this.props.stateActions.setCarouselFocus(0);
        history.push("/brands/" + itemToRedirect?.name);
        break;

      default:
        goToDetailPageByProgramType.call(this, {
          id,
          programType,
          moduleId,
          sectionName: this.state.nameSection,
          from: {
            name: this.props.location.pathname || this.props.from,
            currentFocus: this.props.currentFocus,
            index: focusedMediaControlItemIndex
          }
        });
    }
  }

  goFullCatalog() {
    if(config.get().showExploreAllCTA === true){
    const { history } = this.props;
    const fullCatalogPath = `${routes.explore}${history.location.pathname}`;
    history.push({
      pathname: fullCatalogPath,
      state: {
        sectionName: this.state.nameSection,
        from: {
          name: this.props.location.pathname || this.props.from,
          currentFocus: this.props.currentFocus,
          index: -1
        }
      }
    });
  }
}

  onChangeItem(index) {
    this.props.stateActions.setCarouselItemFocus(index);

    if (this.props.applicationState.focusedCarouselIndex === 0) {
      this.checkTrailerMediaButtonToShow(0, index);
    }
  }

  close4KModal() {
    this.setState({ modal4K: false });
    this.props.setFocus(defaultFocusPath);
  }

  closeConfirmModal() {
    this.setState({ isExiting: false });
    this.props.setFocus(defaultFocusPath);
  }

  appNeedToClose() {
    getSdk().systemManager.application.exit();
    this.closeConfirmModal();
  }

  updateCarouselStateIndexes() {
    // Clear cached heights if not measured from start
    if (!this.cache.has(this.state.scrollToIndex) || Object.keys(this.cache._rowHeightCache).length < 3) {
      this.cache.clearAll();
    }
    // if(this.state.scrollToIndex !== -1 && this.props.currentFocus == headerFocusPath) {
    //   this.props.setFocus(defaultFocusPath);
    // }
    this.props.stateActions.setCarouselFocus(
      this.state.nameSection === "home"
        ? this.state.scrollToIndex
        : [0, 1].includes(this.state.scrollToIndex)
        ? 0
        : this.state.scrollToIndex
    );
    this.props.stateActions.setCarouselItemFocus(0);
  }

  onEnterPlay(is4K = false) {
    // Reset continue watching carousel index
    this.props.stateActions.setCarouselItemFocus(0);
    this.setState({ didPlayerLaunch: true });
    this.props.pauseNavigation();
    play.bind(this, is4K)();
  }

  openFullCatalogLayout() {
    this.setState({ scrollToIndex: 1 }, this.updateCarouselStateIndexes);
    trackEvent("explore catalogue", this.state.nameSection, this.state.nameSection);
    this.goFullCatalog();
  }
  _onModulesUp(isButtons = false) {
    if (this.state.isWheel && this.state.scrollToIndex > 0) {
      this.props.setFocus(defaultFocusPath);
    }
    if (isButtons) {
      this.setState({ isWheel: false });
    }

    const {
      setFocus,
      stateActions: { setMediaControlItemFocus }
    } = this.props;
    if (!!this.state.modules && this.state.scrollToIndex > 0) {
      this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex - 1 }), this.updateCarouselStateIndexes);
    } else if (this.state.hasHeroModule) {
      if (this.state.isWheel) {
        // this.setState({ scrollToIndex: -1 }, () => {
        //   this.updateCarouselStateIndexes();
        //   this.props.setFocus(headerFocusPath);
        // });
        return;
      } else {
        //this.brandName !== "brands" && this.props.setFocus(headerFocusPath);
        /* Decided to hide Media control from hero. so whe user navigateup from hero carousel we need block that event instead of going to media control below
       - two line commented for this reason and return */
        //this.brandName !== "brands" && setFocus('mediaControls');
        //setMediaControlItemFocus();
        return;
      }
    }
  }

  _onModulesDown(isButtons = false) {
    if (this.state.isWheel && this.state.scrollToIndex > -1) {
      this.props.setFocus(defaultFocusPath);
    }
    if (isButtons) {
      this.setState({ isWheel: false });
    }
    const modulesPageSize = config.get().layouts.modulesPageSize;
    if (
      !!this.state.modules &&
      this.state.scrollToIndex <
        amountOfDownloadedModules[this.state.nameSection] - (this.state.nameSection !== "home" ? 0 : 1)
    ) {
      this.setState(({ scrollToIndex }) => ({ scrollToIndex: scrollToIndex + 1 }), this.updateCarouselStateIndexes);
      if (
        amountOfDownloadedModules[this.state.nameSection] - this.state.scrollToIndex <= modulesPageSize &&
        amountOfDownloadedModules[this.state.nameSection] < this.state.modules.modules.length
      ) {
        this.getLayout(
          amountOfDownloadedModules[this.state.nameSection],
          amountOfDownloadedModules[this.state.nameSection] + modulesPageSize
        );
      }
    }
  }

  _onModulesLeft() {
    /*  Commenting/removing logic for Explore button placement on other layout pages if (!!this.state.modules && (this.state.nameSection === "home"  || this.state.scrollToIndex !== 1)) */
    if (!!this.state.modules) {
      this.left(this.state.scrollToIndex);
    }
    this.setState({ isWheel: false, wheelState: "idle" });
  }

  _onModulesRight() {
    if (!!this.state.modules) {
      this.right(this.state.scrollToIndex);
    }
    this.setState({ isWheel: false, wheelState: "idle" });
  }
  onMediaControlsLeft() {
    const isHeaderShown = !noHeader(window.location.pathname);
    if (mediaSlider.state.mediaFocusedIndex > 0) {
      mediaSlider.left();
    } else if (isHeaderShown) {
      this.props.setFocus(headerFocusPath);
      mediaSlider.down();
    }
  }

  onMediaControlsRight() {
    if (mediaSlider.state.mediaFocusedIndex < mediaSlider.state.mediaItemCount) {
      mediaSlider.right();
    }
  }

  onMediaControlsDown() {
    this.props.setFocus(defaultFocusPath);
    this.props.stateActions.setMediaControlItemFocus(-1);
    mediaSlider.down();
  }
  onMediaControlsUp() {
    return;
  }

  getInitialSlide(index) {
    const {
      applicationState: { focusedCarouselIndex, focusedCarouselItemIndex }
    } = this.props;
    const fixedIndex = this.state.nameSection === "home" || index === 0 ? index : index + 1;

    if (
      this.state.modules?.modules[index]?.type.toLowerCase() === "hero" &&
      focusedCarouselItemIndex > this.state.modules?.modules[0]?.titles.length - 1
    ) {
      return 0;
    }
    return this.state.modules.modules[index].category !== CAROUSEL_TYPES.watchlist &&
      fixedIndex === focusedCarouselIndex
      ? focusedCarouselItemIndex
      : 0;
  }

  onRefCarousel(ref) {
    ref && (this.sections[ref.props.carouselIndex] = ref);
  }

  isRowFocused(index) {
    return this.state.scrollToIndex === index;
  }

  isCropped(index) {
    return (
      (index < this.state.scrollToIndex && this.state.scrollToIndex !== this.getListRowCount() - 1) ||
      index > this.state.scrollToIndex
    );
  }

  scrollUpDown(event) {
    if (timer !== null) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      this.setState({ wheelState: "idle" }, () => {
        clearTimeout(timer);
      });
    }, 1000);
    if (event.deltaY > 0) {
      // down wheel moves
      this.setState({ wheelState: "active", scrollDirection: "down" });
      this.onModulesDown();
    } else if (event.deltaY < 0) {
      this.setState({ wheelState: "active", scrollDirection: "up" });
      // up wheel moves
      if (this.props.location.pathname.includes("brands")) {
        if (this.state.scrollToIndex !== 0) {
          this.onModulesUp();
        }
      } else {
        this.onModulesUp();
      }
    }
  }

  slideUpDown(direction) {
    if (direction === "up") {
      this.onModulesUp();
    } else if (direction === "down") {
      this.onModulesDown();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const isBrand = window.location.pathname.includes("brands");
    this.brandName = isBrand && window.location.pathname.split("/")[1];
    const { isExiting } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();

    // FIXME: WBIGS-690 - Remove with new carousel
    if (
      i18n.getDirection() === directions.RIGHT_TO_LEFT &&
      rtlToFix === 1 &&
      this.sections[this.props.applicationState.focusedCarouselIndex]
    ) {
      rtlToFix = 0;
      this.sections[this.props.applicationState.focusedCarouselIndex] &&
        (!this.props.applicationState.userLogged || this.props.applicationState.focusedCarouselIndex !== 1) &&
        this.sections[this.props.applicationState.focusedCarouselIndex].left();
    }
    this.checkLiveCarouselEndOfTheModules();
    this.toggleMediaControls();
  }

  checkTrailerMediaButtonToShow(focusedCarouselIndex = 0, focusedCarouselItemIndex = 0) {
    //if (this.props.currentFocus === 'mainMenu') return;
    if (this.state.modules) {
      let mediaMenu = null;

      if (focusedCarouselIndex === 0) {
        const module = this.state.modules.modules[0];
        const title = module && module.titles[focusedCarouselItemIndex];
        if (!title?.trailerMedia) {
          mediaMenu = this.state.mediaControlMenu.filter(item => item.name !== "trailer");
        } else {
          mediaMenu = getMediaItems();
        }
        this.setState({ mediaControlMenu: mediaMenu });
      }
    }
  }

  toggleMediaControls() {
    return this.props.currentFocus !== "mainMenu" && this.state.scrollToIndex <= 0
      ? mediaSlider?.show()
      : mediaSlider?.hide();
  }

  checkLiveCarouselEndOfTheModules = () => {
    if (this.state.modules) {
      this.state.modules.modules.map((module, index) => {
        if (this.state.modules.total === index + 1 && module?.category === "ListLiveChannels") {
          if (!this.state.isLastRowHeightCache) {
            this.setState({ isLastRowHeightCache: true });
          }
        }
      });
    }
  };
  clearRowHeightCache = () => {
    if (this.state.modules) {
      const modulesLength = this.state.modules ? this.state.modules.total : 0;
      const moduleLastIndex =
        this.state.nameSection !== "home" && modulesLength > 1 ? modulesLength - 1 : modulesLength;
      if (
        this.state.nameSection !== "home" &&
        this.state.modules.modules[moduleLastIndex]?.category === "ListLiveChannels"
      ) {
        this.cache.clearAll();
      }
    }
  };
  shouldComponentUpdate(nextProps, nextState) {
    this.isMagicRemoteActive = nextState.isWheel
      ? true
      : getSdk().systemManager.application.checkMagicRemote()
      ? true
      : false;
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.modules !== this.state.modules ||
      nextState.wheelState !== this.state.wheelState ||
      nextState.scrollToIndex !== this.state.scrollToIndex ||
      // nextState.scrollToIndex == this.state.scrollToIndex ||
      (this.state.modules &&
        nextState.modules.modules.filter(module => !!module.titles).length !==
          amountOfDownloadedModules[this.state.nameSection]) ||
      nextState.modal4K !== this.state.modal4K ||
      nextState.isExiting !== this.state.isExiting ||
      nextState.didPlayerLaunch !== this.state.didPlayerLaunch ||
      nextState.isLoaded !== this.state.isLoaded
    );
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
    // FIXME: WBIGS-690 - Remove with new carousel
    rtlToFix = 2;
  }

  async componentDidMount() {
    //this.setState({mediaControlMenu: getMediaItems()}) ;
    this.setState({ hasHeroModule: false });
    if (["/", "/home"].some(a => a === window?.location?.pathname)) {
      // **** tracking event in only home page ****
      trackEventInitializeData({
        page: "view_landingscreen",
        language: getLocaleFromLocalCache() || "en",
        referring_url: this.props.from
      });
      trackEventPushData({ event: "view_landingscreen" });
    }
    trackPage.call(this, PAGE);
    this.props.onRef(this);
    this.props.resumeNavigation();
    const { history, location, from } = this.props;
    const subscription = findFromBrands(this.state.nameSection, this.props.applicationState.subscriptions || []);
    const baseSubscription = findFromBrands(this.state.nameSection, subscription?.brands);
    this.setState({
      displayName: subscription?.displayName === "STARZPLAY" ? baseSubscription?.displayName : subscription?.displayName
    });

    this.deviceBuilt = await getSdk().systemManager.device.getYear();

    // TODO: I'm not 100% sure, but I would bet removing this await would make the component behave identically
    await this.getLayout();
    this.checkTrailerMediaButtonToShow(0, this.props.applicationState.focusedCarouselItemIndex);
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();

    if (this.brandName === "brands") {
      history.location.referrer !== "/brands" && this.setState({ scrollToIndex: 0 }, this.updateCarouselStateIndexes);
      this.props.setFocus("lists");
    }
    // SHOUD CHECK LATER- NOW SETTING FOCUS ON CAROUSEL
    const prevFocusInfo = location.state?.from || getSavedFocusInfo();
    if (location.pathname === prevFocusInfo?.name) {
      let { currentFocus, index } = prevFocusInfo;
      if (currentFocus === "mediaControls" && index >= 0) {
        this.props.stateActions.setMediaControlItemFocus(index);
      }
      this.props.setFocus(currentFocus || "lists");
      return;
    }
    this.props.setFocus("lists");
  }

  getUserRelatedModulesIndexes() {
    let {
      applicationState: { userRelatedModules }
    } = this.props;
    if (
      (!userRelatedModules && this.state.modules) ||
      (userRelatedModules && !userRelatedModules[`${this.state.nameSection}`] && this.state.modules)
    ) {
      const userModulesIndexes = [];
      for (let i = 0; i < this.state.modules.modules.length; i++) {
        this.state.modules.modules[i].isDynamic === true && userModulesIndexes.push(i);
      }
      if (userModulesIndexes.length > 0) {
        if (!userRelatedModules) this.props.applicationState.userRelatedModules = {};
        const finalUserRelatedModules = Object.assign(this.props.applicationState.userRelatedModules, {
          [`${this.state.nameSection}`]: userModulesIndexes
        });
        localStorage.setItem("userRelatedModules", JSON.stringify(finalUserRelatedModules));
        return finalUserRelatedModules;
      }
    }
    return userRelatedModules;
  }

  getFinalModule() {
    const { nameSection } = this.state;
    return amountOfDownloadedModules[nameSection] > 0
      ? amountOfDownloadedModules[nameSection] - 1
      : config.get().layouts.modulesPageSize;
  }
  /**
   * New logic has implemented always show latest data for avoided cahced modules.
   * This will take Avoided Cached Modules from Local storage if reload ,otherwise take it from App state
   */

  async getCacheAvoidedModulesFromLStore() {
    const userRelatedModulesFromStore = JSON.parse(localStorage.getItem("userRelatedModules")) || null;
    if (
      !this.props.applicationState.userRelatedModules &&
      this.state.nameSection === "home" &&
      userRelatedModulesFromStore &&
      userRelatedModulesFromStore[`${this.state.nameSection}`]
    ) {
      if (!this.props.applicationState.userRelatedModules) this.props.applicationState.userRelatedModules = {};
      await Object.assign(
        this.props.applicationState.userRelatedModules,
        userRelatedModulesFromStore[`${this.state.nameSection}`]
      );
    }
  }

  async getLayout(initialModule = INITIAL_MODULE, finalModule = this.getFinalModule(), refreshLayout = false) {
    await this.getCacheAvoidedModulesFromLStore();
    const {
      applicationState: { userRelatedModules },
      stateActions: { showGlobalModal }
    } = this.props;
    sdk = await getSdk();

    // TODO: Check if it's possible to create a decorator for this type of async calls (X behaviour for isOnline and another one for !isOnline).
    if (getAppState().isOnline) {
      if (!sameLayoutRequestIsInProgress(initialModule, finalModule)) {
        try {
          setLayoutRequestInProgress(initialModule, finalModule);
          const modules = await sdk.mediaManager.getLayout(
            this.state.nameSection,
            {
              initialModule,
              finalModule,
              ...(!!userRelatedModules &&
                userRelatedModules[`${this.state.nameSection}`] &&
                userRelatedModules[`${this.state.nameSection}`].length && {
                  avoidCacheFor: userRelatedModules[`${this.state.nameSection}`]
                }),
              ...(refreshLayout === true && { refreshLayout }),
              version: 2 // parameter send to web sdk for landscape images
            } || []
          );
          const self = this;
          let filteredArray =
            modules &&
            modules.modules &&
            modules.modules.reduce(function(filtered, module) {
              switch (module.category) {
                case "ListBrandsDisabled":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false) module.titles = [...getBrands("IN_ACTIVE", module.category)];
                    else module.titles = [...getSportsAddons("IN_ACTIVE", module.category)];
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListBrandsActive":
                  if (module && module.layoutOrder <= finalModule) {
                    module.type = "channels";
                    if (self.isSports === false)
                      module?.titles?.length > 0 && (module.titles = [...getBrands("ACTIVE", module.category)]);
                    else
                      module?.titles?.length > 0 && (module.titles = [...getSportsAddons("ACTIVE", module.category)]);
                    module?.titles?.length !== 0 && filtered.push(module);
                  }
                  break;
                case "ListLiveChannels":
                  module.type = "LiveChannels";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Items":
                  module.type = "List5Items";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5Org":
                  module.type = "List5Org";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                case "List5TopW":
                  module.type = "List5TopW";
                  module?.titles?.length !== 0 && filtered.push(module);
                  break;
                default:
                  filtered.push(module);
              }
              return filtered;
            }, []);

          modules.modules = [...filteredArray];
          unsetLayoutRequestInProgress();

          amountOfDownloadedModules[this.state.nameSection] =
            Array.isArray(modules.modules) &&
            modules.modules.length > 0 &&
            modules.modules.filter(module => !!module.titles)?.length;
          const module = modules?.modules[0];
          if (module && this.deviceBuilt >= YEAR_CONST) {
            module.titles = module.titles.map((title = {}) => {
              const { images } = title;
              if (images.heroMainFullscreen?.indexOf("data:") === -1) {
                getCacheGeneratedImage(images.heroMainFullscreen, url => {
                  images.heroMainFullscreen = url;
                });
              }
              if (images.posterLandscape?.indexOf("data:") === -1) {
                getCacheGeneratedImage(images.posterLandscape, url => {
                  images.posterLandscape = url;
                });
              }
              return title;
            });
          }
          this.setState({ modules, hasHeroModule: module?.type?.toLowerCase() === "hero" });
          this.props.applicationState.userRelatedModules = this.getUserRelatedModulesIndexes();
        } catch (error) {
          unsetLayoutRequestInProgress();
          console.log(error);
          handleError.call(this, error, finalModule);
        }
      }
    } else {
      if (this.state.modules && this.state.modules.modules.length) {
        const { retry, back } = getErrorHandlingCallbacks.call(this);
        showGlobalModal(
          getInternetConnectivityModalConfig.call(this, {
            retryImplementation: retry,
            backImplementation: back,
            needsDismissableProp: false,
            isTimeout: true
          })
        );
      }
    }
  }

  left(moduleIndex) {
    const module = this.sections[moduleIndex];
    const { selectedIndex } = module;
    if (i18n.getDirection() !== directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      const isHeaderShown = !noHeader(window.location.pathname);
      if (!isHeaderShown) return;
      this.props.setFocus(headerFocusPath);
      return;
    }
    module.left();
  }
  goTo(itemIndex) {
    setTimeout(() => {
      this.sections[this.state.scrollToIndex] && this.sections[this.state.scrollToIndex].goTo(itemIndex);
      this.handleEnter();
    }, 50);
  }

  dontShowEmptyActive() {
    return !getAppState().userLogged;
  }
  right(moduleIndex) {
    const module = this.sections[moduleIndex];
    if (!module) return;
    const { selectedIndex } = module;
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT && selectedIndex === 0) {
      this.props.setFocus(headerFocusPath);
      return;
    }
    module.right();
  }

  getListRowCount() {
    return amountOfDownloadedModules[this.state.nameSection] + (this.state.nameSection !== "home" ? 1 : 0);
  }

  getTitleIcon(title, isUserSubscribedToChannel) {
    const { subscriptions } = getAppState();
    const {
      applicationState: { addons }
    } = this.props;
    const addonName = getAddonName(title.toLowerCase());
    const isTitleInSubscriptions = isChannelAvailable(subscriptions, addonName);
    if (isTitleInSubscriptions) {
      return isUserSubscribedToChannel(addons, addonName) ? (
        <IconStyled name="premiumContentFilled" />
      ) : (
        <IconStyled name="premiumContentEmpty" />
      );
    }
    return undefined;
  }
  getBrandUrl() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return "";
    const brandName = getBrandName(true);
    return getBrandLogoUrl(brandName, this.props.applicationState.subscriptions);
  }

  isStarzSubscription() {
    const isBrand = window.location.pathname.includes("brands/");
    if (!isBrand) return true;
    const brandName = getBrandName(true);
    return isStarzPlaySubscription(brandName, this.props.applicationState.subscriptions);
  }
  rowRenderer({ key, index, parent, style }) {
    const heroLayout = () => (
      <this.TypedCarouselStyledMemo
        onClickPoster={i => this.onClickRow(i, 0)}
        type="hero"
        // items={getTitlesFormattedForCarousels.call(this, "hero", this.state.modules.modules[0].titles)}
        items={getTitlesFormattedForHeroCarousel(this.state.modules.modules[0].titles, isUserAccountActive(this?.props?.applicationState?.userAccountStatus))}
        carouselIndex={0}
        onRef={this.onRefCarousel}
        initialSlide={this.getInitialSlide(0)}
        onChangeItem={this.onChangeItem}
        showArrows={true} //{!!(this.state.isWheel && this.state.wheelState === "active")}
        slideMargin={"0.55rem"}
        direction={i18n.getDirection()}
        style={style}
        MagicRemoteStatus={this.isMagicRemoteActive}
        className={this.isRowFocused(0) ? "focused" : this.isCropped(0) ? "cropped" : "row"}
        brandImageUrl={this.getBrandUrl()}
        isBrand={window.location.pathname.includes("brands/") && true}
        isStarz={this.isStarzSubscription()}
      />
    );

    const fullCatalogLayout = () => (
      config.get().showExploreAllCTA === true && (
      <div style={style}>
        <ButtonStyled
          label={i18n
            .get(
              "pages.layout.exploreAll",
              this.state.displayName || i18n.get(`global.sections.${this.state.nameSection}`)
            )
            .toUpperCase()}
          size="small"
          carouselIndex={index}
          onClick={this.openFullCatalogLayout}
          // background={
          //   this.state.nameSection !== "kids" && `${config.get().ui.urlCdn}/MainMenu/${this.state.nameSection}.jpg`
          // }
          className={this.isRowFocused(index) ? "focused" : this.isCropped(index) ? "cropped" : "row"}
        />
      </div>
      )
    );

    const carouselLayout = (module, moduleIndex) => (
      <this.TypedCarouselStyledMemo
        onClickPoster={i => this.onClickRow(i, module.rowIndex)}
        key={module.id}
        // FIXME: Adapt module type mapping to new types coming from new API (either 'Carousel' or 'cw')
        type={
          module.type.toLowerCase() === "cw"
            ? "watchlist"
            : module.type.toLowerCase() === "channels"
            ? "channels"
            : module.type.toLowerCase() === "livechannels"
            ? "LiveChannels"
            : module.type === "List5Items"
            ? "List5Items"
            : module.type === "List5Org"
            ? "List5Org"
            : module.type === "List5TopW"
            ? "List5TopW"
            : "layout"
        }
        items={getTitlesFormattedForCarousels.call(this, module.type, module.titles)}
        title={
          module.type.toLowerCase() !== "hero" && this.state.nameSection !== "live" && module.type !== "LiveChannels"
            ? module.title
            : ""
        }
        iconTitle={module.type === "LiveChannels" && module.layoutOrder !== 0 ? "live" : ""}
        carouselIndex={index}
        initialSlide={this.getInitialSlide(moduleIndex)}
        onRef={this.onRefCarousel}
        onChangeItem={this.onChangeItem}
        MagicRemoteStatus={this.isMagicRemoteActive}
        slideMargin={Theme.components.carousel.slideMargin.layout}
        marginBottom={module.type.toLowerCase() === "cw" && (props => props.theme.spacing.small)}
        direction={i18n.getDirection()}
        showArrows={true} // {!!(this.state.isWheel && this.state.wheelState === "active")}
        style={style}
        isBrand={window.location.pathname.includes("brands/") && true}
        slideMarginStartLive={
          this.state.nameSection !== "live" &&
          module.type === "LiveChannels" &&
          resolution.carousel.slideMarginStart.homeLive
        }
        isHomePage={this.props.name?.toLowerCase() === "home" ? true : false}
        className={
          this.isRowFocused(index)
            ? `focused ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : this.isCropped(index)
            ? `cropped ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
            : `row ${
                module.type.toLowerCase() === "channels" && module.category === "ListBrandsActive"
                  ? `channelCarosal`
                  : ``
              }`
        }
      />
    );

    const getLayoutRow = index => {
      /** As per the new UI revamp(Android theme) need to place Explore button end of the page , so prevoius logics has to be scrapped. Prevously placed after the first row in grid layout.
       * if (index === 1 && this.state.nameSection !== "home")
       **/

      const moduleData = this.state.modules?.modules[index];
      if (
        moduleData?.id === this.cache._rowHeightCache[moduleData?.id] &&
        index === amountOfDownloadedModules[this.state.nameSection] &&
        this.state.nameSection !== "home"
      ) {
        return fullCatalogLayout();
      } else {
        /*const moduleIndex = this.state.nameSection !== "home" && index > 1 ? index - 1 : index;*/
        const moduleIndex = index;
        const module = this.state.modules.modules[moduleIndex];
        this.state.modules.modules[moduleIndex].rowIndex = index;
        if (module?.type?.toLowerCase() === "hero") {
          return heroLayout();
        } else {
          return carouselLayout(module, moduleIndex);
        }
      }
    };

    return (
      this.isEnabled() && (
        <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
          {getLayoutRow(index)}
        </CellMeasurer>
      )
    );
  }

  getScrollTop(index, height) {
    // FIXME: memoization.
    if (!height || this.cache._cellHeightCache[0] === undefined) {
      return undefined;
    } else if (this.scrollPositions[index]) {
      return this.scrollPositions[index];
    }
    const stopY =
      index > 0
        ? new Array(index)
            .fill(undefined)
            .reduce(
              (prev, current, currentIndex) =>
                prev + this.cache._cellHeightCache[this.cache._keyMapper(currentIndex)] || 0,
              0
            )
        : 0;

    const scrollTop = Math.max(
      stopY - height / 2 + (this.cache._cellHeightCache[this.cache._keyMapper(index)] / 2 || 0),
      0
    );

    this.scrollPositions[index] = scrollTop;
    this.props.stateActions.setLayoutScrollTop(scrollTop);
    return scrollTop;
  }

  isScrollEnd() {
    const modulesLength = this.state.modules ? this.state.modules.modules.length : 0;
    if (this.state.nameSection !== "home") {
      return this.state.scrollToIndex === modulesLength;
    }
    return this.state.scrollToIndex + 1 === modulesLength;
  }

  rowHeightCalculator({ index }) {
    const currentModule = this.state.modules?.modules[index];
    if (currentModule?.type === "LiveChannels") {
      return resolution.live.liveChannelCarouselHeight;
    }
    return this.cache._rowHeightCache[currentModule?.id]
      ? this.cache._rowHeightCache[currentModule?.id]
      : this.cache.rowHeight(index);
  }

  render() {
    const { scrollToIndex, modules, isLoading, modal4K } = this.state;
    const { location } = this.props;
    const isLoaded = this.isEnabled();
    const isLoadedEnabled = this.isEnabled();
    const lastModule = this.isScrollEnd() ? ` isLayoutEnd` : ``;
    const UpArrowStyles = {
      display: this.isMagicRemoteActive && this.state.isWheel && this.state.scrollToIndex > 0 ? "block" : "none"
    };
    const DownArrowStyles = {
      display:
        this.isMagicRemoteActive && this.state.isWheel && this.state.scrollToIndex >= -1 && !this.isScrollEnd()
          ? "block"
          : "none"
    };
    this.state.isLastRowHeightCache && this.clearRowHeightCache();
    // FIXME: Calculate direction to round floor/ceil.
    return (
      <>
        {this.state.isLoaded && isLoadedEnabled ? (
          <>
            <LayoutStyled
              className={
                this.state.isLoaded &&
                isLoadedEnabled &&
                `hasContent${scrollToIndex > 0 ? ` isLayoutScrolling${lastModule}` : ``} ${!this.state.hasHeroModule &&
                  "noHero"}`
              }
              position={
                !this.state.hasHeroModule
                  ? resolution.layout.positionHeaderHidden
                  : resolution.layout.positionHeaderVisible
              }
            >
              <>
                {/*this.brandName !== "brands" && (
                  <ArrowScrollStyled
                    label={
                      this.props.applicationState.userLogged
                        ? i18n.get("pages.layout.searchAndMenu")
                        : i18n.get("pages.layout.loginAndMenu")
                    }
                    icon="arrowUp"
                    isVisible={this.state.scrollToIndex === 0}
                  />
                  )*/}
                <LayoutUpArrow
                  style={UpArrowStyles}
                  onWheel={e => {
                    this.setState({ isWheel: true });
                    this.scrollUpDown(e);
                  }}
                  onClick={() => this.slideUpDown("up")}
                >
                  <AirRemoteArrows arrowDirection={"up"}></AirRemoteArrows>
                </LayoutUpArrow>
                <LayoutDownArrow
                  className="arrowdown"
                  scrollToIndex={this.state.scrollToIndex}
                  style={DownArrowStyles}
                  onWheel={e => {
                    this.setState({ isWheel: true });
                    this.scrollUpDown(e);
                  }}
                  onClick={() => this.slideUpDown("down")}
                >
                  <AirRemoteArrows arrowDirection={"down"}></AirRemoteArrows>
                </LayoutDownArrow>

                {modules.total > 0 ? (
                  <>
                    {this.state.hasHeroModule && this.state.mediaControlMenu && (
                      <MediaControlsListFocus
                        focusPath={"mediaControls"}
                        initialSlideIndex={location.state?.from?.index}
                        onRef={ref => (mediaSlider = ref)}
                        onLeft={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsRight
                            : this.onMediaControlsLeft
                        }
                        onRight={
                          i18n.getDirection() === directions.RIGHT_TO_LEFT
                            ? this.onMediaControlsLeft
                            : this.onMediaControlsRight
                        }
                        onDown={this.onMediaControlsDown}
                        onUp={this.onMediaControlsUp}
                        onEnterPress={this.handleMediaControlsEnter}
                        mediaControlMenu={this.state.mediaControlMenu}
                      />
                    )}
                    <ListFocus
                      onWheel={e => {
                        this.setState({ isWheel: true });
                        this.scrollUpDown(e);
                      }}
                      height={!this.state.hasHeroModule ? height - NO_HEADER_MARGIN_TOP_IN_PX : height}
                      width={width}
                      rowHeight={this.cache.rowHeight}
                      // rowHeight={this.rowHeightCalculator}
                      rowRenderer={this.rowRenderer}
                      rowCount={this.getListRowCount()}
                      columnCount={1}
                      deferredMeasurementCache={this.cache}
                      autoContainerWidth
                      scrollToIndex={scrollToIndex}
                      scrollToAlignment={"center"}
                      style={{ overflowY: "hidden", direction: "inherit" }}
                      overscanRowCount={1}
                      scrollingResetTimeInterval={0}
                      focusPath={defaultFocusPath}
                      onDown={() => this.onModulesDown(true)}
                      onUp={() => this.onModulesUp(true)}
                      onLeft={this.onModulesLeft}
                      onRight={this.onModulesRight}
                      onEnterPress={this.handleEnter}
                    />
                  </>
                ) : (
                  <LayoutEmptyStyled>
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph1")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph2")} />
                    <Text text={i18n.get("pages.layout.emptyScreen.paragraph3")} />
                  </LayoutEmptyStyled>
                )}
              </>
            </LayoutStyled>
            {this.carouselToShowBack && (
              <Toast
                text={i18n.get("pages.layout.backToTop")}
                icon={"remoteBack"}
                size={"small"}
                onClick={this.goTop}
                isVisible={this.state.scrollToIndex > this.carouselToShowBack}
                isIndicator
              />
            )}
            <ShadowLayoutStyled />
          </>
        ) : (
          <Loading overlay opacity="0" />
        )}

        {this.state.modal4K && (
          <ModalSettings headingText={""} mainText={i18n.get("global.4Ksupported")}>
            <ButtonModalFocus
              label={i18n.get("global.play4K")}
              focusPath="play4KModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, true)}
              onMouseUp={this.onEnterPlay.bind(this, true)}
              size="small"
              onRef={ref => (this.play4KModalFocusPath = ref)}
              displayBlock={true}
              dataSnUp={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnDown={i18n.directionFlip("@playHDModal_passThru", "")}
              dataSnLeft={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnRight={i18n.directionFlip("@playHDModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.playHD")}
              focusPath="playHDModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, false)}
              onMouseUp={this.onEnterPlay.bind(this, false)}
              size="small"
              displayBlock={true}
              dataSnUp={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnDown={i18n.directionFlip("", "@play4KModal_passThru")}
              dataSnLeft={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@play4KModal_passThru")}
            />
          </ModalSettings>
        )}
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <ModalSettings
            headingText={i18n.get("global.modals.exit.title")}
            mainText={i18n.get("global.modals.exit.text")}
          >
            <ButtonModalFocus
              label={i18n.get("global.no").toUpperCase()}
              focusPath="noOkModal_passThru"
              onEnterPress={this.closeConfirmModal}
              onMouseUp={this.closeConfirmModal}
              size="small"
              spacing="small"
              displayBlock={true}
              onRef={ref => (this.confirmModalFocusPath = ref)}
              dataSnDown={"@okModal_passThru"}
              dataSnUp={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
            <ButtonModalFocus
              label={i18n.get("global.yes").toUpperCase()}
              focusPath="okModal_passThru"
              onEnterPress={this.appNeedToClose}
              onMouseUp={this.appNeedToClose}
              size="small"
              displayBlock={true}
              dataSnUp={"@noOkModal_passThru"}
              dataSnDown={""}
              dataSnLeft={""}
              dataSnRight={""}
            />
          </ModalSettings>
        )}
      </>
    );
  }
}

const Component = withAppState(
  withSubtheme(props => <Layout currentFocus={props.applicationState.currentFocus} {...props} />)
);

Component.defaultFocusPath = defaultFocusPath;

export default Component;
